import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { actions } from './slice';

export const getValidOrderSearchParam = (
  search: string,
): string | undefined => {
  const order = new URLSearchParams(search).get('order');

  if (!order || !/^\d+$/.test(order)) {
    return undefined;
  }

  return order;
};

export const useOrderSearchParam = (urlOrderSearchEnabled: boolean) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const lastSearchedOrder = React.useRef<string>();

  React.useEffect(() => {
    const order = getValidOrderSearchParam(location.search);

    if (
      !order ||
      !urlOrderSearchEnabled ||
      lastSearchedOrder.current === order
    ) {
      return;
    }

    lastSearchedOrder.current = order;
    dispatch(actions.searchingOrder(true));
    dispatch(actions.updateSearchField(order));

    const nextSearchParams = new URLSearchParams(location.search);
    nextSearchParams.delete('order');
    const nextSearch = nextSearchParams.toString();

    navigate(
      {
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
        hash: location.hash,
      },
      { replace: true },
    );
  }, [
    dispatch,
    location.hash,
    location.pathname,
    location.search,
    navigate,
    urlOrderSearchEnabled,
  ]);
};
